module.exports = __webpack_public_path__ + "static/media/backgroundimage.d9e09ef5.jpg";